var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramFoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 38,
    height: 38,
    rx: 8,
    fill: "#000000",
    stroke: "#ffffff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M28.42 12.52L9.13 19.96C7.81 20.49 7.82 21.23 8.89 21.56L13.84 23.11L25.3 15.89C25.84 15.56 26.33 15.74 25.93 16.1L16.65 24.47H16.64L16.65 24.48L16.31 29.54C16.81 29.54 17.03 29.31 17.31 29.04L19.71 26.71L24.71 30.41C25.63 30.92 26.29 30.65 26.52 29.56L29.8 14.12C30.13 12.79 29.3 12.2 28.42 12.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramFoot);
export default __webpack_public_path__ + "static/media/telegram-foot.078efaf44d4fc1047268c445b5a9aebe.svg";
export { ForwardRef as ReactComponent };